/**
 * Constant definitions
 * @type {
 * {
 * FR_CA: string,
 * EN_US: string,
 * EN_CA: string,
 * SOURCE_ID: string,
 * VALID_LANG: [string, string, string],
 * EXTERNAL_ID: string,
 * DEFAULT_BRAND: string,
 * BRAND_MAPPING: {vw: string, skoda: string, audi: string, vw6: string},
 * VALID_BRANDS: [string, string, string, string],
 * VW_BRAND: string of the brand passed in app props. It is lowercase
 * AUDI_BRAND: string of the brand passed in app props. It is lowercase
 * MESSAGE_CENTER: { subject_mapping_status_active: 1}
 * }}
 */
const constants = {
  // brands that match bronson packaging. See public dir or @vwfs-bronson in node_modules
  VALID_BRANDS: ['audi', 'vw', 'vw6', 'skoda'],
  DEFAULT_BRAND: 'audi',
  DEFAULT_COUNTRY: 'USA',
  CANADA: 'Canada',
  USA: 'USA',
  BRAND_MAPPING: {
    audi: 'Audi',
    vw: 'VW',
    vw6: 'VW',
    skoda: 'Skoda',
  },
  CUSTOMER_MAPPING: {
    primary: 'Primary',
    cobuyer: 'CoBuyer',
    guarantor: 'Guarantor',
    other: 'Other',
  },
  DOCUMENT_MAPPING: {
    Loan: { value: 'Lease/Finance Agreement', text: 'Contract Agreement' },
    Statements: { value: 'Statement', text: 'Statement' },
    AutopayLetter: { value: 'Autopay Enrollment Letter', text: 'AutoPay' },
  },
  vw6: 'VW6',
  VALID_LANG: ['en-US', 'en-CA', 'fr-CA'],
  EN_US: 'en-US',
  EN_CA: 'en-CA',
  FR_CA: 'fr-CA',
  VW_BRAND: 'vw6',
  AUDI_BRAND: 'audi',
  MY_AUDI_SOURCE: 'myAudi',
  MY_AUDI_MOBILE_SOURCE: 'myAudi-app',
  MESSAGE_CENTER: { SUBJECT_MAPPING_STATUS_ACTIVE: 1 },
  SOURCE_ID: 'vci-messagecenter-app',
  EXTERNAL_ID: 'vci-messagecenter-app',
  NAVBAR_POSITION_TOP: 'topbar',
  NAVBAR_POSITION_SIDE: 'sidebar',
  VCI_PORTAL_APP_SOURCE: 'vci-owner-portal',
  MESSAGE_LETTERS_INDICATOR: 15,
  COMPANY_VOLKSWAGEN_FINANCIAL_SERVICES: 'Volkswagen Financial Services',
  COMPANY_AUDI_FINANCIAL_SERVICES: 'Audi Financial Services',
} as const;

export const mediumScreenWidth = 960;
// Gotten from abstract mobile width
export const mobileScreenWidth = 800;

export const TEST_HARNESS_PATH_NAME = '/iframe.html';
export const adobeTaggingConstants = {
  PROD_ENVIRONMENT_LONG: 'Production',
  PROD_ENVIRONMENT: 'prod',
  QA_ENVIRONMENT: 'QA',
  USD_CURRENCY: 'USD',
  CANADIAN_CURRENCY: 'CAD',
};

export default {
  ...constants,
  ...adobeTaggingConstants,
  mediumScreenWidth,
  mobileScreenWidth,
};
